<template>
    <div class="app-update-detail-page">
        <div class="app-update-detail-page__shell">
            <loader-component v-if="loading" />
            <article v-else-if="appUpdate !== null" class="app-update-detail-card">
                <header class="app-update-detail-card__header">
                    <div>
                        <span class="app-update-detail-card__eyebrow">Mise à jour</span>
                        <h5 class="title app-update-detail-card__title">
                            {{ $t("labels.appUpdates.title", { date: displayDate(appUpdate.update_date, DATE_MED) }) }}
                        </h5>
                        <small>{{ $t("labels.appUpdates.lastUpdate", { date: displayDate(appUpdate.updated_at, DATE_MED) }) }}</small>
                    </div>
                    <div class="app-update-detail-card__modules">
                        <span v-for="tmpModule in appUpdate.modules" :key="tmpModule" class="badge text-bg-success me-1">
                            {{ getModuleTypeLabel(tmpModule) }}
                        </span>
                    </div>
                </header>
                <div class="app-update-detail-card__content ck-content" v-html="appUpdate.content"></div>
            </article>
        </div>
    </div>
</template>
<script>
import LoaderComponent from "../../../components/LoaderComponent.vue";
import ModuleTypesEnum from "../../../mixins/enums/ModuleTypesEnum.js";

export default {
    data() {
        return {
            loading: false,
            appUpdate: null,
        };
    },
    mixins: [ModuleTypesEnum],
    computed: {
        appUpdateId() {
            return Number.parseInt(this.$route.params.app_update_id);
        },
    },
    methods: {
        fetchAppUpdate() {
            this.loading = true;

            this.httpGet(`/api/app_updates/${this.appUpdateId}`)
                .then((response) => {
                    if (response !== false) {
                        this.appUpdate = response.data;
                    }
                })
                .finally(() => (this.loading = false));
        },
    },
    created() {
        this.fetchAppUpdate();
    },
    components: {
        LoaderComponent,
    },
};
</script>

<style scoped>
.app-update-detail-page {
    min-height: calc(100vh - 72px);
    padding: 28px 18px 40px;
    background: linear-gradient(180deg, #f7fbfc 0%, #eef8fa 100%);
}

.app-update-detail-page__shell {
    max-width: 1080px;
    margin: 0 auto;
}

.app-update-detail-card {
    padding: 26px;
    border: 1px solid rgba(48, 164, 183, 0.12);
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 18px 45px rgba(15, 58, 72, 0.07);
}

.app-update-detail-card__header {
    display: flex;
    justify-content: space-between;
    gap: 18px;
    padding-bottom: 18px;
    margin-bottom: 22px;
    border-bottom: 1px solid rgba(48, 164, 183, 0.12);
}

.app-update-detail-card__eyebrow {
    display: inline-flex;
    margin-bottom: 8px;
    color: var(--main-color-light, #30a4b7);
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
}

.app-update-detail-card__title {
    margin: 0 0 6px;
    color: #142f3c;
    font-size: 1.45rem;
    font-weight: 700;
}

.app-update-detail-card__header small {
    color: #7b8c95;
}

.app-update-detail-card__modules {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-content: flex-start;
    gap: 6px;
    min-width: 160px;
}

.app-update-detail-card__content {
    overflow-x: auto;
    color: #243b46;
    line-height: 1.65;
}

@media (max-width: 767.98px) {
    .app-update-detail-page {
        padding: 20px 12px 32px;
    }

    .app-update-detail-card {
        padding: 20px;
    }

    .app-update-detail-card__header {
        flex-direction: column;
    }

    .app-update-detail-card__modules {
        justify-content: flex-start;
        min-width: 0;
    }
}
</style>
